import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from 'src/@core/services/notification.service';
import { BehaviorSubject } from 'rxjs';
import { LoginResponse } from 'src/@core/interfaces/login-response.model';
import { EnterpriseAdminService } from '../../../enterprise-admin.service';
import { AppService } from 'src/@core/services/app.service';
import { RolesPermissionsService } from 'src/app/modules/roles-permissions/roles-permissions.service';
import { AddEditRolesComponent } from 'src/app/modules/roles-permissions/roles-list/add-edit-roles/add-edit-roles.component';

@Component({
  selector: 'hour4u-admin-create-team-member',
  templateUrl: './create-team-member.component.html',
  styleUrls: ['./create-team-member.component.scss']
})
export class CreateTeamMemberComponent implements OnInit {
  createTeamMemberForm: FormGroup;
  submitted = false;
  private currentUserSubject = new BehaviorSubject<LoginResponse>(new LoginResponse());
  profile = this.appService.getCurrentAccount();
  loginUserDetails: any = null;
  currentUserRole: any = null;
  addingForWhichRole: any = null;
  isUpdate: boolean = false;
  rolesList: any[] = [];
  pageIndex: number = 0;
  pageSize: number = 200;
  selectedRole: any = null;
  isViewMode: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CreateTeamMemberComponent>,
    private _fb: FormBuilder,
    private notify: NotificationService,
    public enterpriseAdminService: EnterpriseAdminService,
    private appService: AppService,
    public rolesPermissionsService: RolesPermissionsService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.createForm();
    this.getCurrentRole();
    this.getRolesByEntity();
    this.fetchRolesList();
  }

  // fetch roles List
  fetchRolesList() {
    let entityType = this.profile.entity.entityType;
    this.rolesPermissionsService.fetchRolesWithPermissions(
      "",
      this.pageIndex,
      this.pageSize,
      "createdOn",
      "desc",
      []).subscribe(res => {
        if (res && res.content && res.content.length) {
          res.content.forEach(element => {
            const formatAction = action => {
              const [prefix, suffix] = action.split('_');
              // Capitalize the first letter of each part and convert the rest to lowercase
              const formattedPrefix = prefix.charAt(0).toUpperCase() + prefix.slice(1).toLowerCase();
              const formattedSuffix = suffix.charAt(0).toUpperCase() + suffix.slice(1).toLowerCase();
              return `${formattedPrefix} ${formattedSuffix}`;
            };

            element.formattedPermissions = element.permissions.map(formatAction);

          });
          this.rolesList = res.content;
          this.rolesList.forEach(ele => {
            if (ele.roleId == this.selectedRole.roleId) {
              this.createTeamMemberForm.controls['roleId'].setValue(this.selectedRole.roleId);
              this.createTeamMemberForm.controls['roleId'].updateValueAndValidity();
            }
          })
        }
      }, (err => {

      }))
  }

  getCurrentAccount(): any {
    return this.currentUserSubject.getValue();
  }

  getCurrentRole() {
    this.appService.currentUser.subscribe(currentUser => {
      this.loginUserDetails = currentUser;
      if (currentUser && currentUser.roles && currentUser.roles.length) {
        currentUser.roles.forEach(ele => {
          this.currentUserRole = ele;
        })
      }
    })
  }

  // get Roles By Entity name
  getRolesByEntity() {
    if (this.profile) {
      this.enterpriseAdminService.getRolesByEntityName(this.profile.entity.entityType).subscribe(res => {
        res.forEach(element => {
          if (this.currentUserRole == 'AGENCY_ADMIN') {
            if (element.roleName == 'AGENCY_STAFF') {
              this.addingForWhichRole = element;
            }
          }
          if (this.currentUserRole == 'ENTERPRISE_ADMIN') {
            if (element.roleName == 'ENTERPRISE_STAFF') {
              this.addingForWhichRole = element;
            }
          }
        });
      })
    }
  }

  createForm() {
    this.createTeamMemberForm = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      mobile: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10), Validators.maxLength(10)]],
      email: ['', [Validators.required, Validators.email]],
      roleId: ['', [Validators.required]]
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave(): void {
    this.submitted = true;
    console.log(this.createTeamMemberForm, this.addingForWhichRole);
    if (this.createTeamMemberForm.invalid) {
      this.createTeamMemberForm.markAllAsTouched();
      this.submitted = false;
      return;
    } else {
      this.addTeamMember();
    }
  }

  // add Team Member
  addTeamMember(): void {
    if (this.addingForWhichRole) {
      let obj = {
        "mobile": this.createTeamMemberForm.value.mobile,
        "email": this.createTeamMemberForm.value.email,
        "roleId": this.createTeamMemberForm.value.roleId || this.addingForWhichRole.roleId,
        "name": this.createTeamMemberForm.value.name
      }
      this.enterpriseAdminService.createTeamMember(this.profile.entity.id, obj).toPromise()
        .then((res: any) => {
          this.autoApproveTeamMember(res);
        }).catch(err => {
          console.log(err)
          this.submitted = false;
        })
    } else {
      this.notify.error('Proper role not found!');
    }
  }

  // auto Approve Team Member
  autoApproveTeamMember(res) {
    this.enterpriseAdminService.updateTeamMemberStatus(res.id, 'ACCEPTED').toPromise()
      .then((res: any) => {
        this.submitted = false;
        this.notify.showMessage('Team Member Added Successfully!', 3000);
        this.dialogRef.close(res);
      }).catch(err => {
        this.submitted = false;
        console.log(err)
      })
  }

  selectRole(role) {
    console.log(role)
  }

  addRole() {
    let obj = Object.assign({});
    obj.actionTitle = "Add Role";
    const dialogRef = this.dialog.open(AddEditRolesComponent, {
      width: '35%',
      height: '100%',
      position: { right: '0' },
      panelClass: 'add-edit-role-dialog',
      disableClose: true,
      data: obj,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRole = null;
      if (result) {
        this.selectedRole = result;
        console.log(result);
        this.fetchRolesList();
      }
    });
  }
}
